import type { Attachment, SimpleUser } from '@common/types/objects';
import { ExtendedUser, OrganisationScope, NetworkScope, OrganisationFunction } from '@common/types/objects';
import { UserProfileTypes } from '@modules/core/definitions';

export type MembershipTypes = {
  type: 'function';
  membership: OrganisationFunction;
} | {
  type: 'network';
  membership: NetworkScope;
} | {
  type: 'organisation';
  membership: OrganisationScope;
};

export type MembershipRowDropdownProps = MembershipTypes & {
  user: ExtendedUser;
  deleteDisabled?: boolean;
  updateAdmin: (...args: any[]) => any;
};

export type ProfileMembershipsProps = {
  user: ExtendedUser;
  type?: UserProfileTypes;
};

type FileUploadRequest = {
  onProgress: (callback: (progress: number) => void) => void;
  promise: Promise<Attachment>;
};

export type FileItem = FileUploadRequest & {
  id: string;
  file: File;
  onRetry: () => Promise<FileUploadRequest>;
};


export enum ENotesVisibility {
  EMPLOYEE = 'employee',
  ALL_ADMINS = 'all_admins',
  CREATOR = 'creator',
}

export interface NotesModel {
  id: string;
  user_id: string;
  text: string;
  visibility: ENotesVisibility;
  created_by: string | SimpleUser;
  created_at: string;
  attachments: Attachment[];
  deleted_by: string | SimpleUser | null;
  deleted_at: string | null;
}

export type NotesFormData = {
  fileIds: string[] | Attachment[];
} & Omit<NotesModel, 'id' | 'created_at' | 'created_by' | 'user_id' | 'attachments'>;

export type APIResponseNoteCreate = {
  data: NotesModel;
  meta: {
    related: {
      users: SimpleUser[];
    };
  };
};

export type APIResponseNotesList = {
  data: NotesModel[];
  meta: {
    related: {
      users: SimpleUser[];
    };
  };
};

export type APIResponseNotesDelete = {
  data: {
    success: boolean,
    hard_delete: boolean
  };
};
